import styled from "styled-components";

import { Box } from "shared/ui-kit";

export const Card = styled(Box)`
	width: 640px;

	margin: 0 auto;
`;
